<template>
  <div>
    <div class="input-group mb-3" dir="ltr">
      <input
        type="text"
        class="form-control text-center"
        v-model="userInput"
        placeholder="کد را وارد کنید"
        @input="validateCaptcha"
        maxlength="5"
        v-mask="'#####'"
      />
      <div class="input-group-append">
        <img
          :src="captchaImage"
          class="input-group-text"
          :width="width"
          :height="height"
          @click="generateCaptcha"
          title="برای تولید کد جدید روی تصویر کلیک کنید"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaptchaBox",
  props: {
    width: {
      type: Number,
      default: 130,
    },
    height: {
      type: Number,
      default: 37,
    },
  },
  data() {
    return {
      captchaId: "",
      captchaImage: "",
      captchaCode: "",
      userInput: "",
      result: "",
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.generateCaptcha();
    });
  },
  methods: {
    async getApiBaseReady() {
      let base = this.$GetapiBase();
      if (!base) {
        await this.$GetAppsettings();
        base = this.$GetapiBase();
      }
      return base || "";
    },
    async generateCaptcha() {
      try {
        const apiBase = await this.getApiBaseReady();
        const res = await fetch(apiBase + "captcha/generate");
        const data = await res.json();
        this.captchaId = data.captchaId;
        this.captchaImage = data.image;
        this.userInput = "";
        this.result = "";
        this.$emit("update", {
          valid: data.valid,
          captchaId: this.captchaId,
          userInput: this.userInput,
        });
      } catch (error) {
        this.result = "خطا در دریافت کپچا";
        this.$emit("update", {
          valid: false,
          captchaId: "",
          userInput: this.userInput,
        });
      }
    },
    async validateCaptcha() {
      if (this.userInput.length === 5) {
        try {
          const apiBase = await this.getApiBaseReady();
          const res = await fetch(apiBase + "captcha/validate", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              captchaId: this.captchaId,
              userInput: this.userInput,
            }),
          });
          const data = await res.json();
          this.$emit("update", {
            valid: data.valid,
            captchaId: this.captchaId,
            userInput: this.userInput,
          });

          if (data.valid) {
            this.result = "✅ کد صحیح است";
          } else {
            this.result = "⛔ " + data.message;
            this.generateCaptcha();
          }
        } catch (error) {
          this.result = "خطا در اعتبارسنجی کپچا";
          this.$emit("update", {
            valid: false,
            captchaId: this.captchaId,
            userInput: this.userInput,
          });
        }
      } else {
        this.$emit("update", {
          valid: false,
          captchaId: this.captchaId,
          userInput: this.userInput,
        });
      }
    },
  },
};
</script>

<style scoped>
.input-group {
  flex-wrap: nowrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control {
  flex: 1 1 auto;
  min-width: 7rem;
  height: 40px;
  min-height: 40px;
}

.input-group-append {
  flex: 0 0 auto;
}

.input-group-text {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 !important;
  cursor: pointer;
}

.input-group-text img {
  display: block;
  height: 40px;
  width: auto;
  max-width: none;
}
</style>
